module.exports = __webpack_public_path__ + "img/changeroles.b25a3020.png";